module.exports = __webpack_public_path__ + "img/img-failed.1213c9ff.png";